<div class="is-date-navigator">
  <ng-container *ngIf="showSelectFormat" >
    <div class="format-select mr--10">
      <mat-form-field floatLabel="never">
        <mat-select placeholder="{{ 'select_site' | translate }}" [formControl]="formatType"
          (selectionChange)="changeDate($event.value)">
          <mat-option *ngFor="let type of formatypeList" [value]="type">
            {{ type | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </ng-container>

  <mat-form-field floatLabel="never" style="margin-left: 20px; width: 210px;" *ngIf="page!=='dashboard' && showFrequencies">
    <mat-label>{{'Frequenza di acquisizione'|translate}}</mat-label>
    <mat-select (selectionChange)="SelectedFrequency($event)" [(ngModel)]="resultFrequency">
      <mat-option *ngFor="let food of listFrequency" [value]="food">
        {{food.name}}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <button mat-icon-button color="primary" (click)="changeDate(-1)" [disabled]="!canChangeWith(-1)">
    <mat-icon svgIcon="arrow_left"></mat-icon>
  </button>

  <div class="date-label">
    <!-- {{
    dateControl?.value
    | isDate: { format: 'FORMATS.'+this.formatType?.value | translate }
    | titlecase }} -->
    {{ getDate() }}

  </div>

  <button mat-icon-button color="primary" (click)="changeDate(1)" [disabled]="!canChangeWith(1)">
    <mat-icon svgIcon="arrow_right"></mat-icon>
  </button>

  <mat-form-field class="hidden-input">
    <input matInput [formControl]="dateControl" [min]="min" [max]="max" [matDatepicker]="picker"
      (dateChange)="changeDate($event)" />
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>

  <button mat-icon-button color="primary" (click)="picker.open()">
    <mat-icon svgIcon="calendar"></mat-icon>
  </button>



</div>